
function openPopup(pUrl, pWidth, pHeight) {
    if (!pWidth)  pWidth = 800;
    if (!pHeight) pHeight = 600;

    var sWidth  = screen.availWidth;
    var sHeight = screen.availHeight;
    var pTop    = sHeight / 2 - pHeight / 2;
    var pLeft   = sWidth / 2 - pWidth / 2;

    window.open(pUrl, 'popup', 'toolbar=no,location=0,status=no,menubar=no,scrollbars=yes,resizable=yes' +
                    ',width=' + pWidth + ',height=' + pHeight + ',top=' + pTop + ',left=' + pLeft);
}


function openIframePopup(src) {
	var $modal  = $('.popup-modal');
	var $iframe = $modal.find('iframe');

	src += src.indexOf('?') >= 0 ? '&' : '?';
	src += 'popup=1';

	$iframe.off('load').on('load', function() {
		var element = this;

		setTimeout(function() {
			var height      = element.contentWindow.document.body.scrollHeight + 20;
			var maxHeight   = $(window).height() - 80;
			var hasOverflow = false;

			if (height > maxHeight) {
				height = maxHeight;
				hasOverflow = true;
			}

			$iframe.animate({
				'height': height + 'px'
			}, 300, function() {
				$modal.removeClass('loading').toggleClass('has-overflow', hasOverflow);
				$iframe.removeClass('invisible');
				$iframe.contents().find('body').css({
					'height': '100%',
					'overflow': 'auto',
					'-webkit-overflow-scrolling': 'touch'
				});
			});
		}, 200);
	});

	$modal.modal();
	$modal.addClass('loading');
	$iframe.addClass('invisible').css({
		'height': '150px'
	}).attr('src', src);
}


function showAlert(alert, okText) {
	var $popin = $('.alert-popin');
	var $btn   = $popin.find('.btn');

	if ($popin.is(':visible')) {
		return;
	}

	if (okText === undefined) {
		okText = $btn.data('text');
	}

	$btn.text(okText);
	$popin.find('.text').html(alert);
	$popin.modal({
		backdrop: 'static',
		keyboard: false
	});
}


function checkSidebarHeight() {
	$('.sidebar').each(function() {
		var sidebarHeight = $(this).outerHeight(true);
		var windowHeight  = $(window).height();

		windowHeight -= $('.navbar-fixed-top').outerHeight();

		if (sidebarHeight > windowHeight) {
			$(this).addClass('no-affix');
		} else {
			$(this).removeClass('no-affix');
		}
	});
}


function htmlEncode(string) {
	string = $('<div>').text(string).html();
	string = string.replace('"', '&quot;');
	return string;
}


function printOnly($element) {
    $('body').addClass('print-nothing');
    $element.addClass('print');
    window.print();
    $element.removeClass('print');
    $('body').removeClass('print-nothing');
}


// function getScrollbarWidth($element) {
//     var remove = false;
//
//     if (typeof($element) == undefined) {
//         remove = true;
//         var $element = $('<div style="height:1px;overflow-y:scroll;"/>').appendTo('body');
//     }
//
//     var scrollbarWidth = $element[0].offsetWidth - $element[0].clientWidth;
//     if (remove) $element.remove();
//     return scrollbarWidth;
// }
function getScrollbarWidth() {
	if (document.documentElement.scrollHeight <= document.documentElement.clientHeight) return 0;
	return window.innerWidth - document.documentElement.clientWidth;
}


